import { setSelectedTimeTasks as setSelectedTimeTasksDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Row = {};

export type GridRow = Row & { id: number }

export type SsetSelectedTimeTasksProps = ApiMethodBase & {
    tasks: Row[];
    groups: Row[]
};

export async function setSelectedTimeTasks ({
    tasks,
    groups,
    eventEmitter
}: SsetSelectedTimeTasksProps) {
    setSelectedTimeTasksDiagram(tasks,groups);
};
